const state = {
  loading_text: "",
  show_loading: false,
}

const actions = {
  updateLoadingText({ commit }, payload) {
    commit('updateLoadingText', payload)
  },
  updateShowLoading({ commit }, payload) {
    commit('updateShowLoading', payload)
  },
}

const getters = {
  getLoadingText: state => {
    return state.loading_text
  },
  getShowLoading: state => {
    return state.show_loading
  },
}

const mutations = {
  updateLoadingText: (state, payload) => {
    state.loading_text = payload.loading_text;
  },
  updateShowLoading: (state, payload) => {
    state.show_loading = payload.show_loading;
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}